<ion-header>
  <ion-toolbar>
    <ion-title>Search on Untappd</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss(null)">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">

  <ion-card class="ion-no-margin ion-no-padding">
    <ion-card-content class="ion-no-padding">
      <ion-item lines="full">
        <ion-input
          label="Brewery"
          labelPlacement="floating"
          type="text"
          placeholder="Brewery"
          [(ngModel)]="brewery"
        ></ion-input>
      </ion-item>
      <ion-item lines="full">
        <ion-input
          label="Beer"
          labelPlacement="floating"
          type="text"
          [(ngModel)]="beerName"
          placeholder="Beer name"
        ></ion-input>
      </ion-item>
      <div class="ion-padding ion-display-flex ion-flex-column ion-flex-md-row">
        <div>
          <ion-button (click)="search()" class="ps-w-100">
            <ion-icon slot="start" name="search-outline"></ion-icon>
            Search
          </ion-button>
        </div>
      </div>

    </ion-card-content>
  </ion-card>


  <div class="ion-margin-top">
    <ion-card class="ion-no-margin ion-no-padding">
      <ion-card-content class="ion-no-padding">
        @if (searchResult.found > 0) {
          <div class="ion-padding">
            <ion-text color="medium">
              <h6>
                Count: {{searchResult.found}}
              </h6>
            </ion-text>
          </div>
        }
        <ion-list class="ion-no-padding">
          @for (item of searchResult.beers; track item) {
            <ion-item
              button
              (click)="dismiss(item);"
              >
              <ion-avatar slot="start">
                <img [src]="item.beer_label" />
              </ion-avatar>
              <ion-label>{{item.beer_name}}</ion-label>
            </ion-item>
          }
        </ion-list>
        @if (searchResult.found == 0) {
          <div class="ion-padding ion-text-center">
            <strong>No result</strong>
          </div>
        }
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>
